<template>
  <div>
    <!-- expandedItems:{{ expandedItems }} -->
    <!-- schema:{{ schema }} -->

    <v-toolbar
      flat
      v-if="
        (!hideTitle && table_title) ||
          (toolBarControls && toolBarControls.length)
      "
    >
      <h5>{{ capitalize(table_title) }}</h5>
      <!-- <v-toolbar-items> -->
      <v-spacer></v-spacer>
      <v-list-item v-for="(c, i) in toolBarControls" :key="i">
        <v-btn
          :small="true"
          :color="c['v-bind'].color"
          :text="c['v-bind'].text"
          :class="c['v-bind'].class"
          v-if="
            c.default &&
              !$root.isMobile &&
              !$root.isTablet &&
              c['v-bind'] &&
              c[`comp`] == 'v-btn' &&
              !c['v-bind'].hidden &&
              !c.hidden
          "
          @click="customBtnClick(c.id)"
          :loading="customBtnLoading"
        >
          <v-icon
            :class="$vuetify.breakpoint.smAndDown ? 'ma-0' : 'ma-2'"
            v-if="c['v-bind'] && c['v-bind'].icon"
          >
            {{ c["v-bind"].icon }}
          </v-icon>
          {{ c["v-bind"]["input-value"] }}
        </v-btn>

        <component
          v-else-if="
            c.default &&
              !edited &&
              c['v-bind'] &&
              !c['v-bind'].hidden &&
              !hideCtl(c)
          "
          :hidden="c.hidden"
          small
          :is="c[`comp`]"
          :ref="c[`id`]"
          :id="c[`id`]"
          :table="getObject()"
          :style="'width:' + c[`v-bind`].width"
          v-bind="c[`v-bind`]"
        >
          {{ c.value }}
        </component>
      </v-list-item>
      <!-- </v-toolbar-items> -->
    </v-toolbar>
    <!-- vModel: {{ vModel }} -->

    <v-row
      :key="itemsKey"
      :class="
        vModel.length > 1
          ? draggable
            ? $vuetify.breakpoint.smAndDown
              ? 'movable mr-n4 pl-n4 pa-0 ' + k
              : 'movable mr-2 pl-2 ' + k
            : 'mr-2 pl-2'
          : 'ma-0'
      "
    >
      <v-col
        class="item"
        :cols="getColSize(i)"
        v-for="(item, i) in vModel"
        :key="i"
      >
        <!-- :elevation="data_object.schema.elevation" -->
        <v-card
          :flat="vModel.length == 1"
          :class="vModel.length == 1 ? '' : 'ma-2'"
        >
          <v-toolbar
            v-if="!hideToolbar || itemAsHeader"
            :dark="draggable"
            :color="getHeaderColor(item)"
            flat
          >
            <v-btn
              :class="i == selectedIndex ? 'selected-item' : ''"
              text
              @click="expandItem(i, item)"
              v-if="itemAsHeader"
            >
              {{ getHeader(item) }}
            </v-btn>

            <!-- <v-label-button
              :schema="schema[k]"
              :color="draggable ? '' : 'primary'"
              :model_key="k"
              :data_key="nameKey"
              :v-model="parModel"
              :itemModel="item"
              :formModel="formModel"
              :parSchema="schema"
              :k="k"
            />
             -->

            <v-spacer></v-spacer>
            <v-move-button
              v-if="draggable"
              :i="i"
              :dataLength="vModel.length"
              :move="move"
              :schema="schema"
            />

            <v-spacer></v-spacer>
            <v-delete-button
              :k="i"
              v-if="!vBind.noDelete"
              :deleteRec="deleteRec"
            />
          </v-toolbar>

          <v-form-component
            v-if="expandedItems.includes(i) || !collapsible"
            :vBind="vBind"
            :model="vModel[i]"
            :parentModel="parentModel"
            :parModel="parModel"
            :schema="schema[k].properties"
            :parentSchema="parObject || {}"
            :key="allKeys[i] ? allKeys[i].key : 0"
            class="pl-4"
          ></v-form-component>
        </v-card>
      </v-col>
    </v-row>
    <v-label-button
      :schema="schema[k]"
      :model_key="k"
      :data_key="nameKey"
      :v-model="parModel"
      :itemModel="vModel"
      :formModel="formModel"
      :parSchema="schema"
      :k="k"
      :addBtnTitle="addBtnTitle"
      :addBtn="true"
      :addRec="addRec"
      :newValue="newValue"
      v-if="addBtnTitle"
    />
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import axios from "axios";
// import func from "../../vue-temp/vue-editor-bridge";
// import lodash from "lodash";

import * as fun from "../plugins/common";
export default {
  components: {
    VFormComponent: () => import("./FormComponent.vue"),
    VLabelButton: () => import("./LabelButton.vue"),
    VDeleteButton: () => import("./DeleteButton.vue"),
    VMoveButton: () => import("./MoveButton.vue"),
    // VAddButton: () => import("./AddButton.vue"),
  },
  props: {
    vModel: Array,
    parModel: [Object, Array, String],
    parentModel: [Object, Array, String],
    formModel: [Object, Array, String],
    parObject: Object,
    parentObject: Object,
    parentSchema: Object,
    label: String,
    table_title: String,
    hideTitle: Boolean,
    hideToolbar: Boolean,
    itemAsHeader: [String, Array],
    schema: Object,
    k: String,
    vBind: Object,
    elevation: String,
    data_object: Object,
    parentKey: String,
    noDeleteFirst: Boolean,
    noDelete: Boolean,
    newValue: String,
    cols: String,
    dynamicLabel: String,
    collapsible: Boolean,
    expandedIndex: Array,
    toolBarControls: Array,
    filter: String,
    defaultModel: Object,
    tableName: String,
    defaultIndex: Number,
  },
  data() {
    return {
      draggable: false,
      itemsKey: 0,
      allKeys: [],
      expandedItems: [],
      deletedItem: null,
      selectedIndex: 0,
    };
  },
  mounted() {
    var that = this;
    if (this.defaultIndex) {
      this.selectedIndex = this.defaultIndex;
    }
    if (this.expandedIndex) {
      this.expandedItems = this.expandedIndex;
    }
    this.draggable = this.data_object.schema.draggable;
    if (this.vModel && this.vModel.length) {
      this.vModel.forEach((m, i) => {
        var key = {
          id: m._id,
          key: i,
        };
        try {
          if (!m._id) {
            m._id = fun.guid();
          }
        } catch {
          //
        }

        that.allKeys.push(key);
      });
    }
    if (this.filter) {
      this.vModel = eval(this.filter);
    }

    var sort = this.data_object.schema.sort
      ? this.data_object.schema.sort.name
      : "";
    if (sort) {
      this.sortItems(sort);
    }
    this.$root.$on("iteratorUpdated", function(id) {
      var key = that.allKeys.filter((k) => {
        return k.id == id;
      })[0];
      key.key = Math.random();

      // that.itemsKey = !that.itemsKey;
    });
    this.$root.$emit("tableMounted", this);
  },
  methods: {
    getHeader(item) {
      if (Array.isArray(this.itemAsHeader)) {
        var itemAsHeader = "";
        this.itemAsHeader.forEach((i) => {
          itemAsHeader += item[i] + " ";
        });
        return fun.capitalize(itemAsHeader);
      } else {
        return fun.capitalize(item[this.itemAsHeader]);
      }
    },
    customBtnClick(id) {
      console.log(id);
      this.$root.$emit("customBtnClick", {
        tbl: this,
        btn: id,
      });
      event.stopPropagation();
    },
    expandItem(index, item) {
      this.selectedIndex = index;
      if (this.expandedItems.includes(index)) {
        this.expandedItems = this.expandedItems.filter((e) => {
          return e != index;
        });
      } else {
        this.expandedItems.push(index);
      }
      this.$root.$emit("itemSelected", {
        obj: this,
        index: index,
        item: item,
      });
    },
    sortItems(sort) {
      this.vModel.sort((a, b) => {
        return a[sort] - b[sort];
      });
    },
    move(i, after) {
      if (after) {
        this.vModel.move(i, i + 1);
      } else {
        this.vModel.move(i, i - 1);
      }
      this.itemsKey = !this.itemsKey;

      // var row = document.querySelectorAll("." + this.k + ".movable")[0];
      // var cols = row.querySelectorAll(".col.item");
      // var col = cols[i];

      // if (after) {
      //   row.insertBefore(col.nextElementSibling, col);
      // } else {
      //   row.insertBefore(col, col.previousElementSibling);
      // }
    },
    deleteRec(i) {
      var that = this;
      var key = this.vModel[i][this.nameKey] || this.vModel[i];
      this.$root.$confirm
        .open("Delete", "Confirm deleting " + fun.capitalize(key) + "?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            console.log(key);
            this.deletedItem = that.vModel[i];
            that.vModel.splice(i, 1);
            that.itemsKey = !that.itemsKey;
            this.$root.$emit("itemsDeleted", this);
          }
        });
    },
    addRec(r) {
      // var newRec =
      //   (this.k !== "address" && this.schema[this.k].defaultModel) || {};
      // if (this.k == "address") {
      //   newRec = { use_existing: false };
      // }
      var newRec = {};
      try {
        newRec = fun.clone(this.schema[this.k]["v-bind"].newRecordModel) || {};
      } catch (error) {
        newRec = {};
      }
      var props =
        this.schema[this.k].properties ||
        this.schema[this.k].table_properties.schema.properties;
      Object.keys(props).forEach((p) => {
        if (props[p]["object_type"]) {
          newRec[p] = {};
        }
      });
      if (r) {
        newRec[this.nameKey] = r;
      }

      newRec._id = fun.guid();
      this.vModel.push(newRec);
      var key = {
        id: newRec._id,
        key: this.vModel.length - 1,
      };
      this.allKeys.push(key);
      this.itemsKey = !this.itemsKey;
      this.$root.$emit("recordAdded", {
        obj: this,
        rec: newRec,
      });
      // this.$emit("input", this.vModel);
    },
    capitalize(t) {
      return fun.capitalize(t);
    },
    getHeaderColor(item) {
      var key = this.getTitle(item);
      var headerColor = this.data_object.schema.headerColor;
      return headerColor ? this.getColor(headerColor, key) : "";
    },
    getColor(color, key) {
      try {
        return eval(color);
      } catch (error) {
        return "#000";
      }
    },
    getTitle(item) {
      return item[this.nameKey];
    },
    getSchema() {
      var s = this.schema;
      if (this.parentKey && this.parentKey) {
        s = this.parentSchema[this.parentKey].properties;
      }
      return s;
    },
    getColSize(index) {
      const count = this.vModel.length;
      const isLast = index === count - 1;

      if (count % 2 === 1 && isLast) {
        return 12;
      }
      return this.cols || 6;
    },
  },
  watch: {
    vModel: {
      handler: function(newValue, oldValue) {
        this.$emit("input", this.vModel);
      },
      deep: true,
    },
  },
  computed: {
    nameKey() {
      var s = this.getSchema();
      return s[this.k]["name_key"];
    },
    addBtnTitle() {
      var s = this.getSchema();
      return s[this.k]["add_btn_title"];
    },

  },
};
</script>
<style>
.item {
  padding: 0 !important;
  margin: 0 !important;
}
.selected-item {
  background-color: yellow;
}
</style>
